import { showToastAddToCartSuccess } from '@/components/common/toast/toast-cart'
import { showToastMessage } from '@/components/common/toast/toast-message'

export const toast = {
  message: showToastMessage,
  addToCartSuccess: showToastAddToCartSuccess,
}
